import React, { useEffect } from "react";
import HeroArea from "./HeroArea";
import PopularEventArea from "./PopularEventArea";
import ArticlesArea from "./ArticlesArea";


const HomePage = () => {
  useEffect(() => { 
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage">
      <HeroArea />
      <PopularEventArea />
      <ArticlesArea />
    </div>
  );
};

export default HomePage;